<template>
  <div
    class="home"
    style="max-width: 80%; height: 100%; position: relative"
    v-show="num == 1"
  >
    <div
      class="search-bar"
      style="width: 600px; height: 10%; margin-left: 17px"
    >
      <el-input
        placeholder="供应商搜索"
        style="width: 600px"
        v-model="names"
      ></el-input>
      <img
        @click="handleSearchClick"
        style="
          width: 25px;
          height: 29px;
          position: absolute;
          left: 600px;
          top: 10px;
          cursor: pointer;
        "
        :src="imgurl"
        alt=""
      />
    </div>
    <div class="home-content" v-if="list.length > 0">
      <div class="shop-item" v-for="shop in list" :key="shop.id">
        <!-- 商家头部栏 -->
        <div class="shop-header">
          <div class="shop-left">
            <img
              :src="getFullImgUrl(shop.avatarUrl)"
              alt=""
              style="width: 43px; height: 39px"
            />
            <h2 class="shop-name">{{ shop.nickName }}</h2>
            <span class="shop-tag" v-if="shop.mainProduct"
              >主营产品：{{ shop.mainProduct }}</span
            >
          </div>
          <div class="shop-right">
            <el-button class="publish-btn" @click="goMy(shop.id)"
              >进店</el-button
            >
          </div>
        </div>

        <div class="product-scroll-wrap">
          <div class="product-list">
            <div
              class="product-card"
              v-for="item in shop.productList"
              :key="item.id"
              @click="deti(item.id)"
            >
              <div class="product-img">
                <img :src="getFullImgUrl(item.coverUrl)" alt="" />
              </div>
              <div class="product-info">
                <p class="product-title">品名：{{ item.name }}</p>
                <p class="product-title">幅宽：{{ item.width }}</p>
                <p class="product-title">克重：{{ item.weight }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-box">
      <div class="empty-inner">
        <div class="empty-text">没有查询到供应商的信息</div>
      </div>
    </div>
  </div>
  <div class="store-page-container" v-show="num !== 1">
    <div class="account-info">
      <div class="avatar-container">
        <img
          :src="img"
          @error="handleImgError"
          style="
            width: 55px;
            height: 55px;
            border-radius: 50%;
            margin-right: 9px;
          "
        />
      </div>
      <div class="account-details">
        <div class="account-name">{{ name }}</div>
        <div class="account-desc">账号简介：{{ profile }}</div>
        <div class="fans-count">
          <span class="stat-item">{{ followCount }}关注</span>
          <span class="stat-item">{{ fansCount }}粉丝</span>
        </div>
      </div>
    </div>

    <div class="action-buttons sticky-buttons">
      <el-button
        class="custom-btn"
        :class="{ actives: active == 0 }"
        @click="pro()"
        >返回供应商</el-button
      >
      <el-button class="custom-btn" :class="{ actives: active == 1 }"
        >样衣</el-button
      >
    </div>

    <div class="clothes-grid">
      <div
        v-for="(item, index) in productList"
        :key="index"
        class="clothes-item"
        @click="deti(item.id)"
      >
        <div style="height: 80%">
          <img
            :src="getFullImgUrl(item.coverUrl)"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="height: 20%; text-align: center">
          <p class="product-titles">品名：{{ item.name }}</p>
          <p class="product-titles">幅宽：{{ item.width }}</p>
          <p class="product-titles">克重：{{ item.weight }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- 供应商详情弹窗 -->
  <el-dialog
    v-model="dialogVisible"
    width="70%"
    top="5vh"
    :before-close="closeDialog"
    class="product-detail-dialog"
  >
    <div class="dialog-container" v-if="Object.keys(detailData).length">
      <!-- 左侧图片区域-->
      <div class="dialog-left">
        <div class="img-wrap">
          <el-carousel
            v-if="sklist.length > 0"
            height="100%"
            indicator-position="outside"
            :initial-index="indexs"
          >
            <el-carousel-item v-for="(img, index) in sklist" :key="img.url">
              <el-image
                :src="getFullImgUrl(img.url)"
                fit="contain"
                style="
                  width: 100%;
                  height: 100%;
                  display: block;
                  cursor: zoom-in;
                "
                @click="openImgViewer(index)"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
          <div v-else class="empty-img">暂无产品图</div>
        </div>
      </div>

      <!-- 右侧信息区域 完全不变 -->
      <div class="dialog-right">
        <div class="author-header">
          <div class="avatar">
            <el-image
              :src="getFullImgUrl(detailData.belongAvatarUrl)"
              fit="cover"
              circle
              style="width: 48px; height: 48px"
            ></el-image>
          </div>
          <span class="author-name">{{ detailData.belongName }}</span>
          <el-button
            :disabled="detailData.source == 1"
            @click="
              aa(
                detailData.belongId,
                detailData.memberFollowStatus,
                detailData.id
              )
            "
            class="follow-btn"
            type="danger"
            >{{
              detailData.memberFollowStatus == 0 ? "关注" : "已关注"
            }}</el-button
          >
        </div>

        <!-- 产品信息 -->
        <div class="info-block">
          <h6 class="block-title">面料信息：</h6>
          <div class="info-row" style="display: flex">
            <p class="label">品名/编号:</p>
            <p class="val" style="margin-right: 35px">
              {{ detailData.name }}
            </p>
            <p class="label">幅宽:</p>
            <p class="val" style="margin-right: 35px">
              {{ detailData.width }}
            </p>
            <p class="label">克量:</p>
            <p class="val">{{ detailData.weight }}</p>
          </div>

          <div class="info-row">
            <span
              class="label"
              style="width: 32px !important; display: inline-block"
              >成份:</span
            >

            <span class="val">{{ detailData.ingredients }}</span>
          </div>
        </div>
        <div class="product-titless">
          <el-tooltip
            effect="dark"
            :content="detailData.title"
            placement="top"
            popper-append-to-body
          >
            <span>{{ detailData.title }}</span>
          </el-tooltip>
        </div>
        <!-- 产品标题 -->
        <div class="product-title">
          <el-tooltip
            effect="dark"
            :content="detailData.content"
            placement="top"
            popper-append-to-body
          >
            <span>{{ detailData.content }}</span>
          </el-tooltip>
        </div>

        <!-- <div class="supply-tags">
          <div class="supply-tag" style="margin-bottom: 120px">面料供应</div>
          <div class="supply-tag">辅料供应</div>
        </div> -->
      </div>
    </div>

    <el-image-viewer
      v-if="imgViewerVisible"
      :url-list="imgViewerList"
      :initial-index="imgViewerIndex"
      @close="closeImgViewer"
    />
  </el-dialog>
</template>

<script>
import srcs from "../front/lalian.png";
export default {
  name: "FrontHome",

  data() {
    return {
      imgurl: srcs,
      list: [],
      names: "",
      num: 1,

      //进店的字段
      active: 1,
      productList: [],
      userid: "",
      img: "",
      name: "",
      followCount: "",
      fansCount: "",
      profile: "",
      defaultAvatar: "",

      //弹窗相关字段
      dialogVisible: false,
      indexs: 0, //决定轮播图从哪里播的索引
      detailData: {},
      // 图片全屏预览
      imgViewerVisible: false,
      imgViewerList: [],
      imgViewerIndex: 0,
      sklist: [],
      supplierProductId: "",
      supplierType: "",
    };
  },
  mounted() {
    this.supplierProductId = this.$route.query.supplierId;
    this.supplierType = this.$route.query.num;
    this.getlist();
  },
  methods: {
    //弹窗相关js
    async tzs(id) {
      const sendata = {
        productId: id, //产品id
      };
      const res = await this.$api.shouye.add(sendata);
      if (res.data.code == "200") {
        this.detailData = res.data.data;
      }
    },
    async aa(id, foll, cpid) {
      console.log("saass", id);
      const sendata = {
        memberId: id, //用户id
        followStatus: foll == 0 ? 1 : 0, //0未关注 1已关注
      };
      const res = await this.$api.shouye.gz(sendata);
      this.tzs(cpid);
      console.log(res);
    },
    async deti(id) {
      this.sklist = [];
      const sendata = {
        productId: id, //产品id
      };
      console.log("商品ID：", id);
      const res = await this.$api.shouye.add(sendata);

      if (res.data.code == "200") {
        this.detailData = res.data.data;
        this.dialogVisible = true;
        this.sklist.push({ url: res.data.data.coverUrl });
        for (
          let index = 0;
          index < res.data.data.particularsList.length;
          index++
        ) {
          this.sklist.push({ url: res.data.data.particularsList[index].url });
        }
        for (
          let index = 0;
          index < res.data.data.colorcardList.length;
          index++
        ) {
          this.sklist.push({ url: res.data.data.colorcardList[index].url });
        }
        console.log(this.sklist, this.indexs, "包含了什么色卡图集");
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.detailData = {};
      this.imgViewerVisible = false;
      this.imgViewerList = [];
      this.imgViewerIndex = 0;
    },
    // 打开全屏图片预览
    openImgViewer(index) {
      this.imgViewerList = this.sklist.map((item) =>
        this.getFullImgUrl(item.url)
      );
      this.imgViewerIndex = index;
      this.imgViewerVisible = true;
    },
    // 关闭图片预览
    closeImgViewer() {
      this.imgViewerVisible = false;
    },

    //供应商列表js
    handleSearchClick() {
      this.supplierProductId = "";
      this.supplierType = "";
      this.getlist();
    },
    goMy(id) {
      this.num = 2;
      this.userid = id;
      this.user();
      this.users();
      this.userpro();
    },
    async getlist() {
      const sendata = {
        currentPage: 1, //当前页
        pageSize: 100, //每页大小
        complexSearch: this.names, //搜索框(编号，标题，所属人)
        supplierProductId: this.supplierProductId, //官方样衣点击面料/辅料供应时传其id
        supplierType: Number(this.supplierType), //官方样衣点击面料/辅料供应区分1面料 2辅料
      };
      const res = await this.$api.Home.get(sendata);
      if (res.data.code == "200") {
        this.list = res.data.data.list;
        console.log(this.list, "返回了什么");
      } else {
        this.$message.error("查询供应商列表" + res.data.msg);
      }
    },

    //这个是点击进店的js部分
    pro() {
      this.num = 1;
    },
    async users() {
      const res = await this.$api.My.gets({});
      console.log(res, "看看接口");
    },
    async userpro() {
      const sendata = this.userid;
      try {
        const res = await this.$api.My.getpro(sendata);
        console.log(res, "看看接口");
        if (res.data.code == "200") {
          this.productList = res.data.data.list;
          this.productList = res.data.data.list;
        }
      } catch (error) {
        console.error("获取商家产品信息失败：", error);
        this.productList = [];
      }
    },
    getFullImgUrl(url) {
      if (!url) return "";

      if (/^https?:\/\//.test(url)) {
        return url;
      }

      return `https://${url}`;
    },
    async user() {
      const sendata = this.userid;
      try {
        const res = await this.$api.My.get(sendata);
        console.log(res, "看看接口");
        if (res.data.code == "200") {
          this.img =
            this.getFullImgUrl(res.data.data.avatarUrl) || this.defaultAvatar;
          this.name = res.data.data.nickName || "未设置昵称";
          this.followCount = res.data.data.followCount || 0;
          this.fansCount = res.data.data.fansCount || 0;
          this.profile = res.data.data.profile || "";
          // this.version = res.data.data.version || 0;
        }
      } catch (error) {
        console.error("获取用户信息失败：", error);
        this.img = this.defaultAvatar;
      }
    },
    handleImgError(e) {
      e.target.src = this.defaultAvatar;
    },
  },
};
</script>

<style scoped lang="less">
.product-titles {
  font-size: 12px;
  color: #333;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.publish-btn {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333 !important;
  font-weight: 500;
}
.home-content {
  overflow-y: auto !important;
  width: 90%;
  height: 90%;
  padding: 16px;
  padding-top: 20px;
  scrollbar-width: none;
}
.home-content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.shop-item {
  margin-bottom: 32px;
  padding-left: 20px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
}
.shop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  .shop-left {
    display: flex;
    align-items: center;
    gap: 14px;
    .shop-name {
      font-size: 28px;
      font-weight: 600;
      margin: 0;
    }
    .shop-tag {
      padding: 4px 10px;
      background: #ffae00;
      color: black;
      border-radius: 12px;
      font-size: 14px;
    }
  }
  .shop-right {
    display: flex;
    gap: 10px;
  }
}
.product-scroll-wrap {
  position: relative;
  .product-list {
    display: flex;
    gap: 100px;
    overflow-x: auto; /* 允许横向 */
    overflow-y: hidden; /* 禁止竖向滚动 */
    padding-bottom: 12px;
  }

  /* 美化横向滚动条 */
  .product-list::-webkit-scrollbar {
    height: 8px;
  }
  .product-list::-webkit-scrollbar-track {
    background: #eee;
    border-radius: 3px;
  }
  .product-list::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  .product-list::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
}
.product-card {
  cursor: pointer;
  min-width: 200px;
  width: 200px;
  flex-shrink: 0;
  .product-img {
    width: 100%;
    height: 80%;
    background: #f5f5f5;
    img {
      width: 100%;
      height: 100%;
      max-height: 290px;
      object-fit: cover;
    }
  }
  .product-info {
    padding: 8px 4px;
    .product-title {
      font-size: 14px;
      color: #333;
      margin: 0 0 8px;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .product-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .product-price {
        font-size: 20px;
        color: #ff4d4f;
        font-weight: bold;
      }
      .cart-icon {
        font-size: 22px;
        color: #ff7d00;
      }
    }
  }
}
.empty-box {
  width: 100%;
  padding: 80px 20px;
  text-align: center;
  .empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
    opacity: 0.6;
  }
  .empty-text {
    font-size: 16px;
    color: #999;
  }
}

//点击进店的样式
:deep(.custom-btn) {
  background-color: #fff;
  border-color: #ffae00;
  color: #333;
}
:deep(.actives) {
  background-color: #ffae00 !important;
  color: #333;
}
/* 页面容器 */
.store-page-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* 顶部操作栏 */
.top-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}

/* 头像+账号信息*/
.account-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/* .avatar-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #409eff;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
} */

.avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 9px;
}

.account-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.account-desc {
  color: #666;
  margin-bottom: 8px;
}

.fans-count {
  color: #333;
}

.stat-item {
  margin-right: 15px;
}

.sticky-buttons {
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;
  padding: 10px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
  display: flex;
  gap: 20px;
}
.publish-btn-disabled {
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
  color: #999 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

/* 商品 列表*/
.clothes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.clothes-item {
  width: 100%;
  cursor: pointer;
  height: 450px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
}

/* 移动端媒体查询*/
@media (max-width: 768px) {
  .account-info {
    flex-direction: column;
    text-align: center;
  }

  .avatar-container {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .clothes-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sticky-buttons {
    padding: 10px;
  }
}

//弹窗样式
::v-deep .product-detail-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-carousel__container {
    padding: 0 !important;
  }
  .el-carousel__indicators--outside {
    padding-bottom: 20px;
  }
}
::v-deep .el-image-viewer__close {
  right: 150px !important;
}

.dialog-container {
  display: flex;
  width: 100%;
  height: 80vh;
  overflow: hidden;

  .dialog-left {
    overflow: hidden;
    width: 57%;
    background: #ffffff;
    .img-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .el-carousel {
        flex: 1;
        width: 100%;
        padding: 0;
      }
      .empty-img {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        font-size: 16px;
      }
    }
  }

  .dialog-right {
    width: 43%;
    padding: 30px;
    overflow-y: auto;
    padding-top: 0;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 2px;
    }

    .author-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 30px;
      .avatar {
        flex-shrink: 0;
      }
      .author-name {
        font-size: 18px;
        font-weight: 500;
        flex: 1;
      }
      .follow-btn {
        background: #c1272d;
        border: none;
        padding: 6px 18px;
        color: #fff;
      }
    }

    .info-block {
      margin-bottom: 24px;
      .block-title {
        font-size: 16px;
        color: #333;
        font-weight: 700;
        margin-bottom: 16px;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei",
          sans-serif;
      }
      .info-row {
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        margin-bottom: 12px;
        font-size: 13px;
        font-weight: 300; /* Light细体 */

        .label {
          text-align: left;
          color: #333;
          font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
          font-size: 13px;
          font-weight: 300; /* Light细体 */
          display: inline-block;
        }
        .val {
          color: #666;
        }
        &.two-col {
          display: flex;
          gap: 40px;
          .col {
            flex: 1;
          }
        }
      }
    }
    .product-title {
      font-size: 16px;
      font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
      line-height: 1.5;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .product-titless {
      font-size: 16px;
      font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
      line-height: 1.5;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .supply-tags {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 24px;
      .supply-tag {
        background: #fff9cc;
        font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei";
        font-weight: 300; /* Light细体 */
        padding: 8px 12px;
        font-size: 16px;
        color: #333;
      }
    }

    .detail-content {
      line-height: 1.8;
      font-size: 15px;
      color: #444;
      h2 {
        margin: 16px 0 8px;
      }
      strong {
        color: #000;
      }
    }
  }
}

// 弹窗移动端适配
@media (max-width: 768px) {
  ::v-deep .product-detail-dialog {
    width: 98% !important;
  }
  .dialog-container {
    flex-direction: column !important;
    height: auto !important;
    .dialog-left,
    .dialog-right {
      width: 100% !important;
    }
    .dialog-left {
      height: 50vh;
    }
    .dialog-right {
      height: auto;
      max-height: 60vh;
    }
  }
}
</style>